import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Video16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M5 10C5 10.5523 4.55228 11 4 11C3.44772 11 3 10.5523 3 10C3 9.44772 3.44772 9 4 9C4.55228 9 5 9.44772 5 10Z'
      fill='currentColor'
    />
    <path
      d='M8 10C8 10.5523 7.55228 11 7 11C6.44772 11 6 10.5523 6 10C6 9.44772 6.44772 9 7 9C7.55228 9 8 9.44772 8 10Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.5 2.25C0.809644 2.25 0.25 2.80964 0.25 3.5V12.5C0.25 13.1904 0.809645 13.75 1.5 13.75H9.5C10.1904 13.75 10.75 13.1904 10.75 12.5V11.008L14.1408 12.0253C14.9428 12.2659 15.75 11.6653 15.75 10.828V5.17202C15.75 4.3347 14.9428 3.73414 14.1408 3.97474L10.75 4.99198V3.5C10.75 2.80964 10.1904 2.25 9.5 2.25H1.5ZM10.75 6.55803V9.44199L14.25 10.492V5.50803L10.75 6.55803ZM1.75 12.25V3.75H9.25V12.25H1.75Z'
      fill='currentColor'
    />
  </Svg>
);

Video16.displayName = 'Video16';
export default Video16;
